import { defineNuxtPlugin, useSanity } from "#imports";
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide("sanity", useSanity());
});
